(() => {
  'use strict';
  const qs=(s,r=document)=>r.querySelector(s); const qsa=(s,r=document)=>[...r.querySelectorAll(s)];
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents,format){
    if(typeof cents==='string') cents=cents.replace('.','');
    const value=(Number(cents||0)/100).toFixed(2);
    const withComma=value.replace(/\B(?=(\d{3})+(?!\d))/g,',');
    return (format||'${{amount}}').replace('{{amount}}',withComma).replace('{{amount_no_decimals}}',String(Math.round(Number(cents||0)/100))).replace('{{amount_with_comma_separator}}',withComma.replace(/,/g,'X').replace('.',',').replace(/X/g,'.'));
  }

  function initScrollStory(){
    if(reduce) return;
    const hero=qs('[data-uc-scroll-stage]');
    const sections=qsa('#services,#why-us,.uc-process,#reviews,.uc-cta');
    let ticking=false;
    const update=()=>{
      const y=window.scrollY;
      document.documentElement.style.setProperty('--uc-scroll-y',`${y}px`);
      if(hero){
        const rect=hero.getBoundingClientRect();
        const progress=Math.max(0,Math.min(1,-rect.top/Math.max(1,rect.height)));
        hero.style.setProperty('--hero-progress',progress.toFixed(3));
        const scene=qs('[data-uc-scene]',hero);
        if(scene) scene.style.transform=`translate3d(0,${progress*26}px,0) scale(${1-progress*.025})`;
      }
      sections.forEach((section)=>{
        const r=section.getBoundingClientRect();
        const d=Math.abs(r.top+r.height/2-window.innerHeight/2);
        section.classList.toggle('is-scroll-active',d<window.innerHeight*.62);
      });
      ticking=false;
    };
    const onScroll=()=>{if(!ticking){ticking=true;requestAnimationFrame(update)}};
    update(); window.addEventListener('scroll',onScroll,{passive:true}); window.addEventListener('resize',onScroll,{passive:true});
  }

  function initRecommendations(){
    qsa('product-recommendations').forEach((el)=>{
      if(el.dataset.loaded==='true') return;
      const observer=new IntersectionObserver((entries,obs)=>entries.forEach((entry)=>{
        if(!entry.isIntersecting) return; obs.unobserve(el); el.dataset.loaded='true';
        fetch(el.dataset.url).then(r=>r.text()).then(text=>{
          const doc=new DOMParser().parseFromString(text,'text/html');
          const fresh=doc.querySelector('product-recommendations');
          if(fresh&&fresh.innerHTML.trim()) el.innerHTML=fresh.innerHTML;
        }).catch(()=>{});
      }),{rootMargin:'0px 0px 500px 0px'});
      observer.observe(el);
    });
  }

  function initProduct(){
    const root=qs('[data-uc-product]'); if(!root) return;
    const variants=JSON.parse(qs('[data-uc-product-json]',root)?.textContent||'[]');
    const moneyFormat=JSON.parse(qs('[data-uc-money-format]',root)?.textContent||'"${{amount}}"');
    const form=qs('.ucv4-product-form',root); const idInput=qs('[data-uc-variant-id]',root);
    const price=qs('[data-uc-product-price]',root); const compare=qs('[data-uc-product-compare]',root); const save=qs('[data-uc-product-save]',root);
    const add=qs('[data-uc-add-to-cart]',root); const addLabel=qs('[data-uc-add-label]',root); const mobilePrice=qs('[data-uc-mobile-price]',root);
    const optionGroups=qsa('[data-option-position]',root);

    const selectedOptions=()=>optionGroups.map(group=>qs('[data-uc-option]:checked',group)?.value||'');
    const findVariant=()=>variants.find(v=>v.options.every((o,i)=>o===selectedOptions()[i]));
    const applyVariant=(variant)=>{
      if(!variant) return;
      idInput.value=variant.id; price.textContent=money(variant.price,moneyFormat); if(mobilePrice) mobilePrice.textContent=money(variant.price,moneyFormat);
      if(variant.compare_at_price&&variant.compare_at_price>variant.price){
        compare.hidden=false; compare.textContent=money(variant.compare_at_price,moneyFormat);
        const pct=Math.round((variant.compare_at_price-variant.price)*100/variant.compare_at_price); save.hidden=false; save.textContent=`وفّر ${pct}%`;
      } else { compare.hidden=true; save.hidden=true; }
      add.disabled=!variant.available; addLabel.textContent=variant.available?'أضف إلى السلة':'غير متوفر حالياً';
      const url=new URL(location.href); url.searchParams.set('variant',variant.id); history.replaceState({},'',url);
      if(variant.featured_media){ qs(`[data-uc-product-thumb][data-media-id="${variant.featured_media.id}"]`,root)?.click(); }
    };
    qsa('[data-uc-option]',root).forEach(input=>input.addEventListener('change',()=>{
      const group=input.closest('[data-option-position]'); qsa('.ucv4-option-pill',group).forEach(x=>x.classList.remove('is-selected')); input.closest('.ucv4-option-pill').classList.add('is-selected'); qs('[data-selected-option]',group).textContent=input.value; applyVariant(findVariant());
    }));

    qsa('[data-uc-product-thumb]',root).forEach(btn=>btn.addEventListener('click',()=>{
      const id=btn.dataset.mediaId; qsa('[data-uc-product-thumb]',root).forEach(x=>x.classList.toggle('is-active',x===btn));
      qsa('[data-media-id]',qs('[data-uc-product-stage]',root)).forEach(media=>{const active=media.dataset.mediaId===id; media.hidden=!active; media.classList.toggle('is-active',active)});
    }));

    const qty=qs('[data-uc-qty-input]',root); qs('[data-uc-qty-minus]',root)?.addEventListener('click',()=>qty.value=Math.max(1,Number(qty.value||1)-1)); qs('[data-uc-qty-plus]',root)?.addEventListener('click',()=>qty.value=Number(qty.value||1)+1);
    const zoom=qs('[data-uc-product-zoom]',root),lightbox=qs('[data-uc-lightbox]',root),lightImg=qs('[data-uc-lightbox-image]',root);
    zoom?.addEventListener('click',()=>{const img=qs('.ucv4-product-media.is-active img',root)||qs('.ucv4-product-media:not([hidden]) img',root);if(!img)return;lightImg.src=img.currentSrc||img.src;lightbox.hidden=false;document.body.style.overflow='hidden'});
    qs('[data-uc-lightbox-close]',root)?.addEventListener('click',()=>{lightbox.hidden=true;document.body.style.overflow=''}); lightbox?.addEventListener('click',e=>{if(e.target===lightbox){lightbox.hidden=true;document.body.style.overflow=''}});
    document.addEventListener('keydown',e=>{if(e.key==='Escape'&&lightbox&&!lightbox.hidden){lightbox.hidden=true;document.body.style.overflow=''}});

    const mobileBar=qs('[data-uc-mobile-buy]',root); const mobileAdd=qs('[data-uc-mobile-add]',root);
    mobileAdd?.addEventListener('click',()=>add?.click());
    const showBar=()=>mobileBar?.classList.toggle('is-visible',window.innerWidth<=720&&add&&add.getBoundingClientRect().bottom<0);
    showBar(); window.addEventListener('scroll',showBar,{passive:true}); window.addEventListener('resize',showBar,{passive:true});

    form?.addEventListener('submit',()=>{add.classList.add('is-loading');addLabel.textContent='جارٍ الإضافة...'});
  }

  document.addEventListener('DOMContentLoaded',()=>{initScrollStory();initProduct();initRecommendations()});
  document.addEventListener('shopify:section:load',()=>{initScrollStory();initProduct();initRecommendations()});
})();
